import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
// import Shop from './pages/Shop'; // Temporarily disabled
import './App.css';

// ScrollToTop component to handle scroll on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Load jQuery and Bootstrap JS for existing functionality
    const loadScripts = () => {
      // Load jQuery first
      const script1 = document.createElement('script');
      script1.src = './js/jquery.min.js';
      script1.async = false; // Load synchronously to ensure order
      document.body.appendChild(script1);

      // Load Bootstrap after jQuery
      script1.onload = () => {
        const script2 = document.createElement('script');
        script2.src = './js/bootstrap.bundle.min.js';
        script2.async = false;
        document.body.appendChild(script2);

        // Load Lightbox after Bootstrap
        script2.onload = () => {
          const script3 = document.createElement('script');
          script3.src = 'https://cdnjs.cloudflare.com/ajax/libs/lightbox2/2.11.3/js/lightbox.min.js';
          script3.async = true;
          document.body.appendChild(script3);
        };
      };
    };

    loadScripts();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="App main-layout">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/gallery" element={<Gallery />} />
          {/* Boutique - Temporarily disabled
          <Route path="/shop" element={<Shop />} />
          */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

